function envOr(value: string | undefined, fallback: string) {
  return value && value.trim().length > 0 ? value : fallback
}

export const AGENCY_PHONE = envOr(import.meta.env.VITE_CONTACT_PHONE_FR, '04 91 91 06 98')
export const AGENCY_PHONE_INTL = envOr(import.meta.env.VITE_CONTACT_PHONE_INTL, '+33 83 29 10 10')
export const AGENCY_EMAIL = envOr(import.meta.env.VITE_AGENCY_EMAIL, 'contact@massiliavoyages.fr')

export const AGENCY_LOCATION_LABEL = envOr(
  import.meta.env.VITE_AGENCY_LOCATION_LABEL,
  'Massilia Voyages agence Marseille : 17 rue ste barbe 13002 Marseille'
)
export const AGENCY_ADDRESS = envOr(
  import.meta.env.VITE_AGENCY_ADDRESS,
  '17 rue ste barbe, 13002, Marseille'
)
export const AGENCY_OPENING_HOURS_LABEL = envOr(
  import.meta.env.VITE_AGENCY_OPENING_HOURS_LABEL,
  'Ouvert du lundi au vendredi de 08h45 à 17h45 et samedi de 08h45 à 12h15'
)

export const BANK_ACCOUNT_HOLDER = envOr(
  import.meta.env.VITE_BANK_ACCOUNT_HOLDER,
  'MASSILIA VOYAGES'
)
export const BANK_IBAN = envOr(import.meta.env.VITE_BANK_IBAN, 'FR76 3000 4006 3300 0102 2849 642')
export const BANK_BIC = envOr(import.meta.env.VITE_BANK_BIC, 'BNPAFRPPXXX')
export const BANK_NAME = envOr(import.meta.env.VITE_BANK_NAME, 'BNP PARIBAS')

export const REUNION_BANK_ACCOUNT_HOLDER = envOr(
  import.meta.env.VITE_REUNION_BANK_ACCOUNT_HOLDER,
  'SAS MASSILIA VOYAGES OCEAN INDIEN'
)
export const REUNION_BANK_IBAN = envOr(
  import.meta.env.VITE_REUNION_BANK_IBAN,
  'FR76 4191 9094 0102 0563 2429 196'
)
export const REUNION_BANK_BIC = envOr(import.meta.env.VITE_REUNION_BANK_BIC, 'BNPARERXXXX')
export const REUNION_BANK_NAME = envOr(import.meta.env.VITE_REUNION_BANK_NAME, 'BNP PARIBAS')

export const REUNION_PHONE = envOr(import.meta.env.VITE_REUNION_PHONE, '+2622626817878')
export const REUNION_EMAIL = envOr(
  import.meta.env.VITE_REUNION_EMAIL,
  'contact-reunion@massilia-voyages.fr'
)
export const REUNION_ADDRESS = envOr(
  import.meta.env.VITE_REUNION_ADDRESS,
  '17 Rue Victor Schoelcher, 97419 La Possession'
)
export const REUNION_OPENING_HOURS_LABEL = envOr(
  import.meta.env.VITE_REUNION_OPENING_HOURS_LABEL,
  'Ouvert du lundi au vendredi de 09h00 12h30 --- 14h00 17h00 et samedi de 09h00 a 12h00'
)
